import PageHeader from '../../shared/PageHeader'
import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import DailyPatientCensusReport from './reports/patient/DailyPatientCensusReport'
import NewVsFollowupPatientsReport from './reports/patient/NewVsFollowupPatientsReport'
import PatientVisitHistory from './reports/patient/PatientVisitHistory'
import NationalityWiseCensusReport from './reports/patient/NationalityWiseCensusReport'
import DoctorWisePatientReport from './reports/patient/DoctorWisePatientReport'
import MohDailyCensusReport from './reports/patient/MOHDailyCensusReport'

import CustomTabs from '../../shared/CustomTabs'

export const patientReportTabs = t => [
  {
    name: t('Daily Patient Census Report'),
    content: <DailyPatientCensusReport />,
  },
  {
    name: t('New vs Follow-UP Patients Report'),
    content: <NewVsFollowupPatientsReport />,
  },
  {
    name: t('Patient Visit History'),
    content: <PatientVisitHistory />,
  },
  {
    name: t('Nationality Wise Census'),
    content: <NationalityWiseCensusReport />,
  },
  {
    name: t('Doctor Wise Report'),
    content: <DoctorWisePatientReport />,
  },
  {
    name: t('MOH Daily Census Report'),
    content: <MohDailyCensusReport />,
  },
]

function PatientReport() {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { state } = useLocation()
  const prevActiveTab = state?.activeInvoiceTabIndex || 0

  return (
    <div className="main-page-container !overflow-y-auto scrollbar">
      <div className="flex items-center justify-between">
        <PageHeader
          title={t('Patient Reports')}
          iconSize={20}
          Icon={i18n.language === 'en' ? FaArrowCircleLeft : FaArrowCircleRight}
          onIconClick={() => navigate(-1)}
        />
      </div>

      <div className="mt-2 w-full h-full">
        <CustomTabs
          tabs={patientReportTabs(t)}
          activeTabIndex={prevActiveTab}
        />
      </div>
    </div>
  )
}

export default PatientReport
